import FileDisplay from "@/components/file_display"
import { extraRefTs } from "@/page/intentRegistration/type"
import { baseURL } from "@/util/network/axios"
import { beforeuploadSpecial, keyPureMath, preview, uploadparams } from "@/util/public"
import { downloadFile, previewFile } from "@/util/util"
import { useUpdateEffect } from "ahooks"
import { Form, Radio, Select, Upload, message } from "antd"
import { LgButton, LgInput, LgTextarea } from "lancoo-web-ui"
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react"
import SelectAddress from "./SelectAddress"
import "./extraItem.scss"
import { useSelector } from "react-redux"
import { selectSchoolId } from "../../../store/reducers/schoolInfo"

interface extraprops {
    // 是否编辑
    editmsg?: any
    form?: any
    setfile?: (value?: any) => void | Function
    item: any
    name: any
    isPreview?: boolean
    lgSelectWidth?: string
    type?: number
}


const ExtraItem = forwardRef<extraRefTs, extraprops>((props, ref) => {
    const { item, name, setfile, form, editmsg, isPreview = false, lgSelectWidth = '100%', type } = props;

    const [, forceUpdate] = useState<any>(null); // 用于触发重新渲染的状态
    const schoolId = useSelector(selectSchoolId);

    const [filelist, setfilelist] = useState<any>([]);

    // 单选以及其他
    const [isother, setisother] = useState<boolean>(false);
    // 其它时内容
    const [radioValue, setradioValue] = useState<string>("");

    useEffect(() => {
        // 设置自定义选项值
        if (item?.optionVOList?.length > 0 && !editmsg) {
            // 手动报名时设置默认选项值为第一个
            // if (item.type == 2 || item.type == 8) {
            //     form.setFieldsValue({
            //         [name]: item.optionVOList[0].value
            //     })
            // }
        }
        if (editmsg) {
            let exMsg: any[] = editmsg?.supplementaryInfoDTOList || [];
            switch (item?.type) {
                case 2:
                    // 单选 判断是否有补充信息
                    if (editmsg?.supplementaryInfoDTOList?.length > 0) {
                        let cvalue = exMsg?.find((item1: any) => item1.fieldId == item.fieldId) ?
                            exMsg?.find((item1: any) => item1.fieldId == item.fieldId).value : isPreview ? '--' : ""
                        form.setFieldsValue({
                            [name]: cvalue
                        })
                        forceUpdate({});
                    }
                    break;
                case 6:
                    let cItem = exMsg?.find((item1: any) => item1.fieldId == item.fieldId)
                    if (cItem?.resources?.length > 0) {
                        let nresList = cItem?.resources?.map((item: any) => {
                            return {
                                name: item.originalName,
                                uid: item.resId,
                                url: item.preUrl,
                                status: 'done',
                            }
                        }) || []
                        setfilelist(nresList)
                        form.setFieldsValue({
                            [name]: nresList
                        })
                        forceUpdate({});
                    }
                    break;
                case 8:
                    // 单选 判断是否有补充信息
                    if (editmsg?.supplementaryInfoDTOList?.length > 0) {
                        let cvalue = exMsg?.find((item1: any) => item1.fieldId == item.fieldId) ?
                            exMsg?.find((item1: any) => item1.fieldId == item.fieldId).value : isPreview ? '--' : ""
                        if (cvalue.indexOf('other:') != -1) {
                            setisother(true)
                            setradioValue(cvalue.slice(6))
                        }
                        form.setFieldsValue({
                            [name]: cvalue
                        })
                        forceUpdate({});
                    }
                    break;
                case 11:
                    // 单选 判断是否有补充信息
                    if (editmsg?.supplementaryInfoDTOList?.length > 0) {
                        const otherInfo = exMsg.find((ele: any) => ele.fieldId == item.fieldId);
                        let cvalue = otherInfo?.options?.find?.((item1: any) => item1.value == otherInfo.value) || (isPreview ? '--' : "")
                        handleAddressChange(cvalue.name);
                        form.setFieldsValue({ [name]: cvalue.value })
                        // form.setFieldsValue({ [name + '11']: cvalue.value })
                        // form.setFieldsValue({ [name]: cvalue.name })
                        forceUpdate({})
                    }
                    break;
                default:
                    let value = exMsg?.find((item1: any) => item1.fieldId == item.fieldId) ?
                        exMsg?.find((item1: any) => item1.fieldId == item.fieldId).value : isPreview ? '--' : ""
                    form.setFieldsValue({
                        [name]: value
                    })
                    forceUpdate({});
                    break;
            }
        }
    }, [item, editmsg]);

    useImperativeHandle(ref, () => ({
        reset: () => {
            setfilelist([]);
            setisother(false);
            setradioValue('');
        }

    }));

    const uploaddone = (info: any, type?: any) => {
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.status !== 0) {
                message.warning(res.msg)
            } else {
            }
        }
    }
    function splitStringByDelimiter(str: string, delimiter: any, partIndex: number = 3) {
        const parts = str.split(delimiter);

        let result: string = '';
        if (parts?.length >= partIndex) {
            result = parts.slice(partIndex - 1).join(delimiter);
        } else {
            result = '';
        }

        return result;
    }

    useUpdateEffect(() => {
        setfile && setfile(filelist)
        forceUpdate({});
    }, [filelist])

    // 设置表单项
    const normFile = (e: any) => {
        if (item.type == 6) {
            setfilelist(e && e.fileList)
            return e && e.fileList
        } else if (item.type == 8) {
            return e.target.value
        } else if (item.type == 4 || item.type == 7) {
            const { value } = e.target;
            const tempArr = value.split(".");
            if (tempArr[1]?.length) {
                return `${tempArr[0]}.${tempArr[1].slice(0, 1)}`.replace(
                    /[^\d{1,}\.\d{1,}|\d{1,}]/g,
                    ""
                );
            } else {
                return value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, "");
            }
        }
        else {
            return e?.target?.value
        }

    }
    const handleAddressChange = (value: string) => {
        form.setFieldsValue({
            [name]: value
        })
        forceUpdate({});
    }

    const TypeCom = (type: any, value: any) => {
        let noptions: any[] = item.optionVOList
        if (type == 8) {
            let cindex = noptions.findIndex((item: any) => item.value == -1)
            if (cindex != -1) {
                noptions.splice(cindex, 1)
            }
        }
        switch (type) {
            case 1:
                return isPreview ? <span>{value || '--'}</span> : <LgInput
                    maxLength={20}
                    style={{ width: lgSelectWidth }}
                    // placeholder={item?.description}
                    placeholder={item.remark ? item.remark : item.optionVOList.length > 0 ? item.optionVOList[0].value : ''}
                    autoComplete="off" className="selfmsg"
                />
            case 2:
                return (
                    isPreview ? <span>{item?.optionVOList?.find(ele => ele.value === value)?.name || value || '--'}</span> : <Radio.Group
                        onChange={() => {
                            form.validateFields([name]); // 校验指定字段
                        }}
                    >
                        {
                            item?.optionVOList?.map((item: any, index: number) => {
                                return (
                                    <Radio
                                        style={{ height: "32px", lineHeight: "32px" }}
                                        key={'options' + index} value={item.value}>{item.name}</Radio>
                                )
                            }) || null
                        }
                    </Radio.Group >

                )
            case 8:
                return (
                    isPreview ? <span>{item?.optionVOList?.find(ele => ele.value === value)?.name || value || '--'}</span> :
                        <Radio.Group style={{ marginTop: "5px" }}>
                            {
                                item?.optionVOList?.length > 0 ?
                                    noptions?.map((item: any, index: number) => {
                                        return (
                                            <Radio onClick={() => setisother(false)} key={'options' + index} value={item.value}>{item.name}</Radio>
                                        )
                                    })
                                    : null
                            }
                            <Radio value={'other:' + radioValue}
                                onClick={() => setisother(true)}
                                style={{ display: "flex", width: "100%" }}>
                                <div className="otheRadio">
                                    <label style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            form.setFieldsValue({
                                                [name]: 'other:' + radioValue
                                            })
                                            setisother(true)
                                            forceUpdate({});
                                        }
                                        }
                                    >其他</label>
                                    {
                                        isother ?
                                            <LgInput
                                                value={radioValue}
                                                maxLength={25}
                                                onChange={(e: any) => {
                                                    setradioValue(e.target.value)
                                                    form.setFieldsValue({
                                                        [name]: 'other:' + e.target.value
                                                    })
                                                    forceUpdate({});
                                                }}
                                                // readOnly={form.getFieldValue()[name] == 'others' ? true : false}
                                                className="selfmsg"
                                            /> : null
                                    }

                                </div>

                            </Radio>

                        </Radio.Group>
                )
            case 4:
                return isPreview ? <span>{value || '--'}</span> : <LgInput
                    autoComplete="off"
                    // type={'number'}
                    maxLength={20}
                    style={{ width: lgSelectWidth }}
                    placeholder={item?.optionVOList?.length > 0 ? (`请输入` + `${item.optionVOList[0].value}~${item.optionVOList[1].value}` + `范围内的值`) : ''}
                    onKeyPress={(event) => keyPureMath(event, ['+', 'e', 'E', '-'])}
                    // onPressEnter={(event) => keyPureMath(event, ['+', 'e', 'E', '-'])}
                    className="selfmsg"
                />
            case 7:
                return isPreview ? <span>{value || '--'}</span> : <LgInput
                    style={{ width: lgSelectWidth }}
                    placeholder={item?.optionVOList?.length > 0 ? (`请输入` + `${item.optionVOList[0].value}~${item.optionVOList[1].value}` + `范围内的值`) : ''}
                    autoComplete="off"
                    // type={'number'}
                    maxLength={20}
                    // onKeyPress={(event) => keyPureMath(event, ['+', 'e', 'E', '-', '.'])}
                    onKeyPress={(event) => keyPureMath(event, ['+', 'e', 'E', '-'])}
                    // onPressEnter={(event) => keyPureMath(event, ['+', 'e', 'E', '-', '.'])}
                    className="selfmsg"
                />
            case 6:
                return isPreview ? <span>
                    {value?.length > 0 ? value?.map((ele: any) => {
                        return <FileDisplay
                            download={() => {
                                downloadFile(ele?.url || ele?.preUrl, ele?.originalName || ele?.name)
                            }}
                            show={() => { previewFile(ele) }}
                            key={ele.uid || ele.url}
                            file={ele.name}
                            panel
                        />
                    }) : '暂无相关文件资料'}
                </span> : <Upload
                    action={baseURL + "/common/uploadfile2"}
                    headers={{ schoolid: schoolId}}
                    // maxCount={1}
                    data={(file) => uploadparams(file, "")}
                    // accept="image/*"
                    // showUploadList={false}
                    fileList={filelist}
                    listType="text"
                    // beforeUpload={beforeuploadSpecial}
                    beforeUpload={(file) =>
                        beforeuploadSpecial(file, filelist)
                    }
                    itemRender={(originNode, file, currentFileList) => {
                        return (
                            <div
                                className="upedlist"
                                style={{ cursor: "pointer", position: "relative" }}
                            >
                                <div
                                    onClick={() => preview(file)}
                                    style={{ position: "absolute", left: "0px", top: "0px", height: "100%", width: "calc(100% - 24px)", zIndex: "3" }}></div>
                                {originNode}
                            </div>
                        )
                    }}
                    accept=".doc, .docx, .pdf, .jpg, .jepg, .png, .excel, .xls, .zip"
                    onChange={file => {
                        let fileList = file.fileList.map((ele: any) => {
                            return {
                                ...ele,
                                ...(ele.response?.data || {})
                            }
                        })
                        form.setFieldsValue({ [name]: fileList }); // 更新表单值
                        form.validateFields([name]); // 校验指定字段
                        uploaddone(file);
                        forceUpdate({});
                    }}
                >
                    {(!form.getFieldValue(name)?.length || lgSelectWidth === '100%') &&
                        <LgButton
                            className="_uploadfile"
                            value={'上传文件'}
                            shapeType='text'
                            style={{ textDecoration: "none", width: "110px", marginLeft: "0px", paddingLeft: "20px" }}
                            showIcon
                            icon={<div style={{ marginRight: "2px", width: "14px", height: "14px" }} className='_uploadico' />}
                        />
                    }
                </Upload>
            case 10:
                const text = isPreview ? (value?.split?.('~')?.slice?.(1)?.join?.('')?.replace?.(/^(.*?)(~.*)?$/, '$1$2'.replace(/~$/, '')) || value) : value
                return isPreview ? <span>{text || '--'}</span> : <SelectAddress onChange={(value: string) => handleAddressChange(value)} required={item.need == 1} />
            case 11:
                return (
                    isPreview ? <span>{item?.optionVOList?.find(ele => ele.value === value)?.name || value || '--'}</span> : <Select
                        options={item.optionVOList?.map((item: any, index: number) => {
                            return {
                                label: item.name || item.label || '',
                                value: item.value
                            }
                        })}
                        className={'CommonSelect lgselect' + item.fieldId}
                        placeholder={`请选择${item.description}`}
                        onChange={(_, curOption: any) => {
                            handleAddressChange(curOption.label);
                            // form.setFieldsValue({ [name + '11']: curOption.value })
                            form.setFieldsValue({ [name]: curOption.value })
                            forceUpdate({});
                        }}
                        style={{ width: lgSelectWidth }}
                        getPopupContainer={(node) => node.parentNode}
                    />
                )
            case 12:
                return isPreview ? <span>{value || '--'}</span> : <LgTextarea
                    numberOfWords={!isPreview}
                    className='textarea-warp'
                    // style={{ maxWidth: "400px" }}
                    textarea={{
                        placeholder: item.remark ? item.remark : item.optionVOList.length > 0 ? isPreview ? '--' : item.optionVOList[0].value : isPreview ? '--' : '',
                        readOnly: isPreview,
                        // showCount: {!isPreview},
                        onInput: (e: any) => {
                            handleAddressChange(e.target.value);
                        },
                        maxLength: 150,
                    }}
                />
            default:
                return isPreview ? <span>{value || '--'}</span> : <LgInput
                    style={{ maxWidth: "400px", width: "100%" }}
                    placeholder={item.remark ? item.remark : item.optionVOList.length > 0 ? isPreview ? '--' : item.optionVOList[0].value : isPreview ? '--' : ''}
                    maxLength={20}
                    className="selfmsg"
                />
        }
    }
    const isOneRow = [2, 6, 10, 12].includes(item.type)
    const colData = useMemo(() => {
        const labelCol = (isOneRow && type !== 3) ? { span: 3 } : { span: 10 }
        const wrapperCol = (isOneRow && type !== 3) ? { span: 21 } : { span: 14 }
        return {
            labelCol,
            wrapperCol
        }
    }, [isPreview])

    return (
        <Form.Item
            className="extraItem"
            name={name}
            label={<div title={item.description}>{item.description}</div>}
            initialValue={
                // (item.type == 2 || item.type == 8) && item.optionVOList && item.optionVOList.length > 0 ?
                //     item.optionVOList[0].value : ""
                item.type === 11 ? null : ""
            }
            // labelCol={colData.labelCol}
            // wrapperCol={colData.wrapperCol}
            getValueFromEvent={normFile}
            style={{
                marginBottom: item.type == 6 ? "12px" : "16px",
                marginTop: item.type == 6 ? "0px" : "0px"
            }}
            rules={[
                {
                    required: item.need == 1 ? !isPreview : false,
                    message: item.type == 10 ? '' : `${item.description + ((item.type == 2 || item.type == 8 || item.type == 11) ? '为必选项！' : '不能为空!')}`
                },
                ({ getFieldValue }) => ({
                    validator(_, value) {
                        if (item.type == 4 || item.type == 7) {
                            if (!value || (item?.optionVOList?.length > 1 &&
                                (
                                    (Number(value) >= item?.optionVOList?.[0]?.value)
                                    &&
                                    Number(value) <= item?.optionVOList?.[1]?.value
                                )
                            )
                            ) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('输入值不在有效范围内'));
                        } else if (item.type == 10) {
                            // if (value?.split('~')?.[0]?.length < 7 && item.need == 1) {
                            //     return Promise.reject(new Error(`所在地区需要选择完！`));
                            // } else 
                            if (!splitStringByDelimiter(value, '~') && item.need == 1) {
                                return Promise.reject(new Error(`详细地址必填！`));
                            }
                            return Promise.resolve();
                        } else if (item.type == 8) {
                            if (value == "other:") {
                                return Promise.reject(new Error(`请填写其它项信息`));
                            }
                            return Promise.resolve();
                        } else {
                            return Promise.resolve();
                        }
                    },
                }),
            ]}
        // normalize={value => value?.trim?.()}
        >
            {
                TypeCom(item.type, form.getFieldValue()[name])
            }
        </Form.Item >
    )
})

export default ExtraItem;
